import React, { Suspense, useMemo } from "react";
import { baseUrl, fetchKmsData } from "@kaltura/mediaspace-shared-utils";
import DetailsSkeleton from "./DetailsSkeleton";
import { ErrorBoundary } from "@kaltura/mediaspace-shared-ui";
import { BaseEntryResultType } from "@kaltura/mediaspace-shared-types";
import Details, { DetailsDetailedProps } from "./Details";

export interface DetailsContainerProps {
    searchResult: Pick<BaseEntryResultType, "mediaTypeName" | "publishData"> & {
        object: {
            id: string;
        };
    };
    className: string;
    categoryId?: number;
    metaDataFetchUrl?: string;
}

/**
 * explore search-result details Suspense container
 */
export function DetailsContainer(props: DetailsContainerProps) {
    const { searchResult, className, categoryId } = props;
    const { mediaTypeName } = searchResult;
    const { id: entryId } = searchResult.object;

    // fetch data from kms
    const fetchMetadata = useMemo(() => {
        let url =
            baseUrl + "/global-search/explore-details/id/" + entryId + (categoryId ? "/category/" + categoryId : "");
        if (props.metaDataFetchUrl) {
            url = props.metaDataFetchUrl;
        }
        return fetchKmsData<DetailsDetailedProps>(url);
    }, [props.metaDataFetchUrl, entryId, categoryId]);

    // render with Suspense
    return (
        <ErrorBoundary fallback={<DetailsSkeleton />}>
            <div className={className}>
                <Suspense fallback={<DetailsSkeleton />}>
                    <Details
                        fetchMetadata={fetchMetadata}
                        entryId={entryId}
                        publishData={searchResult.publishData}
                        mediaTypeName={mediaTypeName}
                    />
                </Suspense>
            </div>
        </ErrorBoundary>
    );
}

export default DetailsContainer;
